import castArray from 'lodash/castArray';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import store from '../store/index';

class CacheFind {
  constructor() {
    this.cache = {};
  }

  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.$cacheFind = this;
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$cacheFind = this;
    this.Vue = Vue;
  }

  async find(id, service, key, query, force) {
    if (!this.cache[id]) this.cache[id] = {};
    if (!this.cache[id][key] || Date.now() - this.cache[id][key].time > 300 * 1000 || force) {
      this.loading = true;
      const res = await store.dispatch(`${service}/find`, { query });
      if (Array.isArray(res)) {
        this.cache[id][key] = { data: res };
      } else {
        this.cache[id][key] = res;
      }
      this.cache[id][key].time = Date.now();

      if (Object.keys(this.cache[id]).length > 20) {
        const oldest = Math.min(...Object.values(this.cache[id]).map(({ time }) => time));
        const oldestKey = Object.keys(this.cache[id])
          .find(i => this.cache[id][i].time === oldest);
        this.$set(this.cache[id], oldestKey, null);
        delete this.cache[id][oldestKey];
      }
    }
    this.cache[id][key].time = Date.now();
    return this.cache[id][key];
  }

  async loadMissing(service, data, field) {
    const ids = uniq(data.reduce((a, item) => [...a, ...castArray(get(item, field, []))], []));
    const { data: existing } = store.getters[`${service}/find`]({ query: { _id: { $in: ids } } });
    const missingIds = ids.filter(id => !existing.some(u => u._id === id));
    if (missingIds.length) {
      await store.dispatch(`${service}/find`, { query: { _id: { $in: missingIds }, $limit: missingIds.length } });
    }
    Math.random(this);
  }
}

export default new CacheFind();
